import { Modal } from '../components/modal.js';

export function burger() {
    const modal = new Modal;

    const burgerBtn = document.querySelector('[am-block="burger"]');
    const burgerMenu = document.querySelector('[am-menu="burger"]');
    const burgerCitiesBtn = document.querySelectorAll('.js-citiesBurger');
    const burgerCities = document.querySelector('[am-cities="burger"]');
    const headerCityMob = document.querySelector('.js-headerCityMob');
    const logoWrapper = document.querySelector('.js-logoWrapper');

    burgerBtn.addEventListener('click', () => {
        if (burgerCities.classList.contains('is-active')) {
            burgerCities.classList.remove('is-active');
            burgerBtn.classList.remove('is-active');
            burgerMenu.classList.remove('is-active');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if (!burgerMenu.classList.contains('is-active')) {
                burgerBtn.classList.remove('is-active');

                let $checkCity = document.querySelector('[am-block="checkCity"]');
                if ($checkCity) {
                    $checkCity.classList.remove('is-active');
                }
            }

            return false;
        }

        logoWrapper.classList.remove('is-active');
        headerCityMob.classList.remove('is-active');
        burgerBtn.classList.toggle('is-active');
        burgerMenu.classList.toggle('is-active');

        if (burgerMenu.classList.contains('is-active')) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            let windowScroll = document.documentElement.scrollTop || document.body.scrollTop;

            if (windowScroll > 10) {
                if (window.innerWidth <= 767) {
                    headerCityMob.classList.add('is-active');
                }
                logoWrapper.classList.add('is-active');
            }
        }
    });

    if (window.innerWidth > 767) {
        burgerCitiesBtn.forEach(item => item.dataset.block = 'cities');
    }

    burgerCitiesBtn.forEach(item => {
        item.addEventListener('click', () => {
            if (window.innerWidth > 767) {
                modal.open('modal', 'cities', 'close');
                return false;
            }
            burgerCities.classList.add('is-active');
            burgerBtn.classList.add('is-active')
        });
    });

}